// extracted by mini-css-extract-plugin
export default {"addNotesOpModalWrap":"AddNotesOp_addNotesOpModalWrap__t3m06","addNotesOpFormMobile":"AddNotesOp_addNotesOpFormMobile__E0eWC","submitRow":"AddNotesOp_submitRow__ybnvk"};